module.exports = "/_next/static/images/logo-black-d0ed3c838010dd2df312126ff5936ed0.png";